module.exports = __webpack_public_path__ + "static/hutch_logo_white-c25fb6ff17b19d9ab8362f6a39cb202f.png";